import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { FormulareServiceModule } from '..';
import { SavedFormulareFiltersComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    FormulareServiceModule
  ],
  declarations: [SavedFormulareFiltersComponent],
  exports: [SavedFormulareFiltersComponent],

})
export class SavedFormulareFiltersComponentModule { }
